import React, {useEffect, useState} from 'react';
import {
  IconBuilding,
  IconCar,
  IconFolder,
  IconID,
  // IconNotification,
  IconSearch
} from "../../../components/icons";
import {useAuth} from "../../contexts/AuthContext";
import {useFormik} from "formik";
import {useNavigate} from "react-router-dom";
import {useHeader} from "../../contexts/HeaderContext";

const Header = ({title}: { title: string }) => {
  const navigate = useNavigate();
  const {currentUser} = useAuth();
  const {lastSearch, setLastSearch, sources} = useHeader();
  const [search, setSearch] = useState<string>(lastSearch ?? "");
  const [displayFilter, setDisplayFilter] = useState<boolean>(false);

  // Formik pour la recherche globale
  const formik = useFormik({
    initialValues: {
      search: search ? search : '',
    },
    enableReinitialize: true,
    onSubmit: ({search}) => {
      // Enregistrement de la dernière recherche dans le HeaderContext
      setLastSearch(search);

      let state = null;
      // Source et Reference : Si le format de la recherche est XXX-000000
      if (/^[A-Za-z]{3}-\d{1,10}$/.test(search)) {
        let source = search.split('-')[0];
        let reference = search.split('-')[1];
        state = {
          isSecondaire: true,
          currentPage: 1,
          source: source,
          reference: reference,
        };
        // Source : Si le format de la recherche contient les libelles de sources
      } else if (sources.some(item =>
        item?.libelle?.includes((search.trim().toUpperCase()))
      )) {
        state = {
          isSecondaire: true,
          currentPage: 1,
          source: search,
        };
        // Marque et Modèle : Si le format de la recherche est deux mots au minimum séparé par espace
      } else if (/^[A-Za-z0-9-./]+ +[A-Za-z0-9-./]+( +[A-Za-z0-9-./]+)*$/.test(search)) {
        state = {
          isSecondaire: true,
          currentPage: 1,
          marque: /\s/.test(search) ? search.slice(0, search.indexOf(' ')) : search,
          modele: /\s/.test(search) ? search.slice(search.indexOf(' ') + 1) : '',
        };
        // Sinon recherche par Immatriculation ou Reference
      } else {
        state = {
          isSecondaire: true,
          currentPage: 1,
          immatriculation: search,
          reference: search,
          marque: search,
          modele: search,
        };
      }

      // Navigation vers dossiers avec les bons state pour la recherche globale
      navigate("/dossiers", {state});
    },
  });

  // useEffect pour modifier search avec les données de lastSearch dans HeaderContext
  useEffect(() => {
    setSearch(lastSearch);
  }, [lastSearch]);

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-3 sticky top-0 z-30">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-gray-900">{title}</h2>
          {(currentUser) ? (
            <p className="text-gray-500 text-sm">
              Bienvenue, {currentUser?.nomUtilisateur || `${currentUser?.nom} ${currentUser?.prenom}`}
            </p>
          ) : null}
        </div>
        <div
          onMouseOver={() => setDisplayFilter(true)}
          onMouseOut={() => setDisplayFilter(false)}
          className="flex items-center gap-3"
        >
          <div className="relative">
            <form onSubmit={formik.handleSubmit} autoComplete="off">
              <input
                name="search"
                type="text"
                placeholder="Rechercher..."
                className="pl-8 pr-4 py-1.5 w-48 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-green-500"
                onChange={formik.handleChange}
                value={formik.values.search}
              />
            </form>
            <IconSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"/>
            {(displayFilter) && (
              <>
                <div className="absolute min-w-[195px] mt-2 z-30 text-sm text-gray-600">
                  <div className="absolute -mt-1 ml-4 w-2 h-2 border-l border-t border-white/1 rotate-45 bg-white"/>
                  <div className="section-card shadow-lg p-4 space-y-2">
                    <div className="flex items-center gap-2 pb-2 border-b border-white/1">
                      <div className="w-5"><IconFolder/></div>
                      <span>Référence dossier</span>
                    </div>
                    <div className="flex items-center gap-2 pb-2 border-b border-white/1">
                      <div className="w-5"><IconBuilding/></div>
                      <span>Source dossier</span>
                    </div>
                    <div className="flex items-center gap-2 pb-2 border-b border-white/1">
                      <div className="w-5"><IconID/></div>
                      <span>Immatriculation</span>
                    </div>
                    <div className="flex items-center gap-2 pb-2 border-b border-white/1">
                      <div className="w-5"><IconCar/></div>
                      <span>Marque du véhicule</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-5"><IconCar/></div>
                      <span>Modèle du véhicule</span>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          {/*<button className="relative p-1.5 text-gray-400 hover:text-gray-600">*/}
          {/*  <IconNotification/>*/}
          {/*  <span className="absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>*/}
          {/*</button>*/}
        </div>
      </div>
    </header>
  );
}

export {Header};